import MuiSkeleton from '@mui/material/Skeleton'

import { styled } from '@mui/material/styles'

const Skeleton = styled(MuiSkeleton)(({ theme }) => ({
  height: theme.sizes.spacing['10'],
}))

export default Skeleton
